import { styled } from 'mz-ui-kit'

export const Form = styled('form', {
  display: 'flex',
  flexFlow: 'column nowrap',
  marginBottom: '20px',
  '@media (max-width: 768px)': {
    padding: '0 16px',
  },
})

export const Buttons = styled('div', {
  marginTop: '10px',
  display: 'flex',
  flexFlow: 'row nowrap',
  '@media (max-width: 768px)': {
    flexDirection: 'column',
    gap: '10px',
  },
})

export const ButtonWrapper = styled('div', {
  ':not(:last-child)': {
    marginRight: '10px',
  },
  '@media (max-width: 768px)': {
    ':not(:last-child)': {
      marginRight: '0',
    },
  },
})

export const ResponsiveRow = styled('div', {
  display: 'flex',
  flexFlow: 'row nowrap',
  gap: '10px',
  '@media (max-width: 768px)': {
    flexDirection: 'column',
    gap: '16px',
    '& > *': {
      width: '100%',
    },
  },
})

export const CollapsibleWrapper = styled('div', ({ $collapsed }) => ({
  '@media (max-width: 768px)': {
    display: $collapsed ? 'none' : 'block',
  },
}))

export const ToggleButton = styled('button', ({ $palette }) => ({
  display: 'none',
  '@media (max-width: 768px)': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    padding: '12px 16px',
    marginBottom: '10px',
    backgroundColor: `${$palette('GRAY').lighten(20)}`,
    border: `1px solid ${$palette('GRAY')}`,
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '500',
    color: `${$palette('TEXT')}`,
    '&:hover': {
      backgroundColor: `${$palette('GRAY').lighten(10)}`,
    },
  },
}))

export const ToggleIcon = styled('span', {
  transition: 'transform 0.2s ease',
  '&.expanded': {
    transform: 'rotate(180deg)',
  },
})
